import React from 'react';
import { getFieldValue, RichText } from '@sitecore-jss/sitecore-jss-react';
import styled from 'styled-components';
import { scrollToSection } from 'utils/scrollTo';
import cx from 'classnames';
import useBreakpoint from 'utils/hooks/useBreakpoint';

const ButtonContainer = styled.div`
  ${({ isMobile }) => isMobile && 'bottom: 0.625rem'}
`;

const Button = styled.button`
  min-height: 3.73rem;
`;

const AnchorLinkBar = ({ fields = {} }) => {
  const { linkText } = fields;
  const anchorLinkPosition = getFieldValue(fields, 'anchorLinkPosition');

  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs'].includes(breakpoint);

  if (!linkText || !anchorLinkPosition) {
    return null;
  }

  return (
    <ButtonContainer
      className='z-30 fixed md:bottom-0 w-screen px-8 md:px-0'
      isMobile={isMobile}
    >
      <Button
        className={cx(
          'rounded-lg md:rounded-none w-full flex items-start justify-center bg-action-blue p-4 md:py-4 md:px-0 focus:outline-none',
        )}
        onClick={() => {
          scrollToSection(anchorLinkPosition);
        }}
      >
        <span className='text-white font-graphie'>
          <RichText tag='span' className='richtext' field={linkText}></RichText>
        </span>
      </Button>
    </ButtonContainer>
  );
};

export default AnchorLinkBar;
